export default __webpack_public_path__ + "static/media/C2_18_x_24_Blanc.2c771bb7.jpg";